import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { pickerLocaleProps } from '../../Helpers/dates';

const DbeDatePicker = function DbeDatePicker({
  date,
  onChange,
  inputFormat = 'dd/MM/yyyy',
  staticPicker = false,
  views = null,
  width = '100%',
  FormHelperTextProps = null,
  ...props
}) {
  const PickerComponent = staticPicker ? StaticDatePicker : DatePicker;
  const componentProps = !staticPicker
    ? {
        inputFormat,
        slotProps: {
          textField: {
            ...props,
            slotProps: {
              input: { style: { borderRadius: '12px' } },
              formHelperText: FormHelperTextProps,
            },
          },
        },
        ...props,
      }
    : { ...props };

  const formats = {
    normalDate: inputFormat,
    keyboardDate: inputFormat,
  };

  const formattedDate = (providedDate) => {
    const timestamp = Date.parse(providedDate);

    if (timestamp <= 0 || isNaN(timestamp)) {
      return null;
    }
    return new Date(date);
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      {...pickerLocaleProps}
      dateFormats={formats}
    >
      <PickerComponent
        id="date-picker"
        value={formattedDate(date)}
        onChange={onChange}
        views={views}
        sx={{ width: staticPicker ? 'auto' : width }}
        {...componentProps}
      />
    </LocalizationProvider>
  );
};

export default DbeDatePicker;
